import React, { useContext, useEffect, useState, useRef } from 'react';
import styled from 'styled-components/macro';
import Button from '@material-ui/core/Button';
import { TextField, TextAreaField, OptionSelect } from '../UI';
import EditorContext from '../../../modules/contexts/editor';
import figma from "../../../modules/libs/figma";
import { makeStyles } from "@material-ui/core";
import Menu from "@material-ui/core/Menu/Menu";
import Divider from "@material-ui/core/Divider";
import MenuItem from "@material-ui/core/MenuItem";
import { styleMap } from '../../../modules/defines/style';

const EditLinkButton = styled(Button)`
    width: 30%;
    align-self: center;
`;

const useMenuClasses = makeStyles({
    paper: {
        borderRadius: 3,
        marginTop: 3,
        boxShadow: '0 3px 1px -2px rgb(0 0 0 / 20%), 0 2px 2px 0 rgb(0 0 0 / 14%), 0 1px 5px 0 rgb(0 0 0 / 12%)',
    },
    list: {
        fontSize: 9,
        color: '#6a6a6a',
    }
});

const useMenuItemClasses = makeStyles({
    root: {
        lineHeight: 1.2,
        padding: '4px 10px',
        minHeight: 'unset',
    }
});

export const Text = ({ node, field }) => {
    const editor = useContext(EditorContext);
    const textRef = useRef(null);
    const [link, setLink] = useState(null);
    const [style, setStyle] = useState(null);
    const [activeSelection, setActiveSelection] = useState(false);
    const changed = useRef(false);
    const [showContextMenu, setShowContextMenu] = useState(false);
    const menuClasses = useMenuClasses();
    const menuItemClasses = useMenuItemClasses();

    const onBlur = () => {
        if (changed.current && textRef.current) {
            editor.updateElementField(node, field, 'value', textRef.current.value);
            // // sorry, any edits kills all links & styles, user has to re-add them
            field.links = [];
            editor.updateElementField(node, field, 'links', field.links);
            field.styles = [];
            editor.updateElementField(node, field, 'styles', field.styles);
            editor.commitNodeUpdate(node);
            setLink(null);
            setStyle(null);
        }
    };

    const onContextMenu = (e) => {
        if (!field.src) {
            if (changed.current && textRef.current) {
                editor.updateElementField(node, field, 'value', textRef.current.value);
                editor.commitNodeUpdate(node);
            }
            changed.current = false;
            setActiveSelection(false);
            if (textRef.current && textRef.current.selectionStart !== textRef.current.selectionEnd) {
                setActiveSelection(true);
                e.preventDefault();
                if (changed.current)
                    editor.updateElementField(node, field, 'value', textRef.current.value);
                setShowContextMenu({ mouseX: e.clientX, mouseY: e.clientY, e });
            }
        }
    };

    useEffect(() => {
        if (textRef.current) {
            // textRef.current.onmousedown = onContextMenu;
            textRef.current.oncontextmenu = onContextMenu;
        }
        setLink(null); setStyle(null);
    }, [node, field]);

    const updateLink = (e) => {
        link.ref = e.target.value;
        editor.updateElementField(node, field, 'links', field.links);
        editor.commitNodeUpdate(node);
        setLink(null);
    };

    const updateStyle = (e) => {
        style.style = e.target.value;
        editor.updateElementField(node, field, 'styles', field.styles);
        editor.commitNodeUpdate(node);
        setStyle(null);
    };

    // request text & link selection from the figma side
    const editLink = (e) => {
        if (textRef.current) {
            const selectedText = textRef.current.value.substr(textRef.current.selectionStart, textRef.current.selectionEnd - textRef.current.selectionStart);
            if (!field.links) {
                field.links = [];
            }
            var thisLink = field.links.find(l => l.linkText === selectedText);
            if (!thisLink) {
                thisLink = { start: textRef.current.selectionStart, end: textRef.current.selectionEnd, linkText: selectedText, ref: '' };
                field.links.push(thisLink);
            }
            setLink(thisLink);
        }
        setShowContextMenu(null);
    };

    const editStyle = (e) => {
        if (textRef.current) {
            textRef.current.blur();
            const selectedText = textRef.current.value.substr(textRef.current.selectionStart, textRef.current.selectionEnd - textRef.current.selectionStart);
            if (!field.styles) {
                field.styles = [];
            }
            var thisStyle = field.styles.find(l => l.styledText === selectedText);
            if (!thisStyle) {
                thisStyle = { start: textRef.current.selectionStart, end: textRef.current.selectionEnd, styledText: selectedText, style: '' };
                field.styles.push(thisStyle);
            }
            setStyle(thisStyle);
        }
        setShowContextMenu(null);
    };

    return (
        <>
            <TextAreaField
                label={field.label} disabled={Boolean(field.src)}
                inputRef={input => {
                    textRef.current = input;
                    if (input)
                        input.value = changed.current && textRef.current ? textRef.current.value : editor.fieldValue(node, field.name);
                }}
                onChange={() => { changed.current = true; }}
                onBlur={onBlur}
                onClick={e => { setLink(null); setStyle(null); }}
            />
            { showContextMenu && (
                <Menu
                    classes={menuClasses} open={Boolean(showContextMenu)} onClose={() => setShowContextMenu(null)}
                    anchorReference="anchorPosition"
                    anchorPosition={{ top: showContextMenu.mouseY + 8, left: showContextMenu.mouseX - 50 }}
                >
                    <MenuItem classes={menuItemClasses} onClick={editLink}>Add/Edit Link</MenuItem>
                    <MenuItem classes={menuItemClasses} onClick={editStyle}>Add/Edit Style</MenuItem>
                </Menu>
            )}
            { link && activeSelection && (
                <TextField label={`Link for "${link.linkText}"`} inputRef={input => { if (input) input.value = link.ref; }} onBlur={updateLink} />
            )}
            { style && activeSelection && (
                <OptionSelect node={node} field={{label: `Style for "${style.styledText}"`, value: style.style || 'default', choices: Object.getOwnPropertyNames(styleMap).sort() }} onSelect={updateStyle} />
            )}
        </>
    );
};


